import React from 'react';
import { Button } from 'semantic-ui-react';
import styled from 'styled-components';

const FoundTemplates = ({
  templates,
  handleCheckTemplate,
  isLoad,
  errMess,
  selectedTemplateId,
  toggleIsOpened,
  tabSelected,
}) => {
  if (errMess) {
    return <TemplateErrMess>{errMess}</TemplateErrMess>;
  }
  if (isLoad) {
    return <Spinner />;
  }

  const onHandleCheckTemplate = (template) => {
    toggleIsOpened();
    handleCheckTemplate(template, 0);
  };
  const chooseFromCertainDay = (template) => {
    toggleIsOpened();
    handleCheckTemplate(template, tabSelected);
  };

  return (
    <FoundTemplatesContainer>
      {templates &&
        templates.map((template) => {
          return (
            <TemplateItem
              key={template.complex_menu_id + template.name}
              selected={template.complex_menu_id === selectedTemplateId}
            >
              <TemplateConstent>
                <Name>{template.name}</Name>
                {!!template.description && <Description>{template.description}</Description>}
                <Description>
                  Среднее количество калорий в день: <strong>{template.avg_calories}</strong>
                </Description>
                <Description>Продолжительность курса: {template.days} дней</Description>
              </TemplateConstent>
              <ButtonBlock>
                {!!tabSelected && (
                  <ButtonBlock>
                    <Button
                      size="mini"
                      positive
                      onClick={() => chooseFromCertainDay(template, tabSelected)}
                    >
                      Выбрать c {tabSelected + 1} дня
                    </Button>
                  </ButtonBlock>
                )}
                <ButtonBlock>
                  <Button size="mini" positive onClick={() => onHandleCheckTemplate(template)}>
                    Выбрать
                  </Button>
                </ButtonBlock>
              </ButtonBlock>
            </TemplateItem>
          );
        })}
    </FoundTemplatesContainer>
  );
};

export default FoundTemplates;

const Name = styled.p`
  margin: 0;
  padding: 0;
  word-break: break-all;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 5px;
`;

const Description = styled.p`
  white-space: normal;
  word-break: break-all;
  font-size: 12px;
  margin: 0;
  padding: 0;
  display: flex;
`;

const TemplateConstent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const ButtonBlock = styled.div`
  display: flex;
  align-items: center;
`;

const FoundTemplatesContainer = styled.div`
  width: 100%;
  padding: 10px 10px 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const TemplateItem = styled.div`
  margin-bottom: 10px;
  width: 95%;
  display: flex;
  justify-content: space-between;
  background-color: ${(props) => (props.selected ? '#393939' : '#ffffff')};
  color: ${(props) => (props.selected ? '#ffffff' : '#393939')};
  border: 1px solid #c1c1c1;
  border-radius: 5px;
  cursor: pointer;
  padding: 5px;
`;

export const Spinner = styled.div`
  display: inline-block;
  margin: 20px;
  width: 50px;
  height: 50px;
  border: 5px solid rgb(3, 3, 3);
  border-radius: 50%;
  border-top-color: rgba(0, 0, 0, 0);
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;

  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
`;

export const TemplateErrMess = styled.div`
  color: #afafaf;
  font-size: 20px;
  margin: 20px 0;
`;



// WEBPACK FOOTER //
// ./src/Components/Common/FindTemplateContainer/FoundTemplates.jsx